import React from "react";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { Tasks } from "./Tasks";
import { DropDownIcon } from "../../assets/svg/DropDownIcon";
import { GetHook } from "../../api/api";
import { TASKS_URL } from "../../api/urls";
import { useHistory, useParams } from "react-router-dom";
import { get } from "../../utils/get";
import { useSortTasks } from "../timeboard/Timeline";

export const TasksContent = ({ user }: any) => {
  const { data: tasks } = GetHook(`${TASKS_URL}?owners=${get(user, "id")}`);
  const sortedTasks = useSortTasks(tasks, user);
  const data = sortedTasks.slice(0, 3);
  const history = useHistory();
  const params = useParams();
  return (
    <>
      <TaskHeader>
        <TitleText>Incoming tasks</TitleText>
        <TasksLabel>
          <TitleText>{Array.isArray(data) && data.length}</TitleText>
        </TasksLabel>
      </TaskHeader>
      <TasksContentContainer>
        <TasksHeader>
          <TitleText>Time</TitleText>
          <VerticalLine />
          <TitleText>Task</TitleText>
        </TasksHeader>
        <div>
          {data.map((task) => (
            <Tasks key={task?.id} data={task} />
          ))}
        </div>
        <h2
          onClick={() => history.push(`/${get(params, "id")}/timeboard`)}
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#214160",
            textAlign: "right",
            right: "0px",
            cursor: "pointer",
          }}
        >
          See all tasks{" "}
          <DropDownIcon
            transform="rotate(270)"
            style={{ marginLeft: "10px" }}
          />
        </h2>
      </TasksContentContainer>
    </>
  );
};

const TasksContentContainer = styled.div`
  background-color: #fff;
  margin: 2em;
  display: grid;
  grid-template-rows: 3em auto 2em;
  grid-column-gap: 0.5em;
  border-radius: 20px;
  padding: 2em;
  ${TitleText} {
    color: #214160;
    font-weight: 400;
  }
`;

const TasksHeader = styled.div`
  display: grid;
  grid-template-columns: 3em 1em auto;
  grid-column-gap: 1em;
`;

const VerticalLine = styled.div`
  height: 100%;
  border-right: 1px solid #ebeeff;
  justify-self: center;
`;

const TaskHeader = styled.div`
  display: grid;
  height: 100%;
  align-items: center;
  grid-template-columns: 8fr 1fr;
  border-bottom: 1px solid #ebeeff;
  padding: 0 1em;
`;

const TasksLabel = styled.div`
  display: flex;
  height: 2em;
  width: 2em;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #ebeeff;
  border-radius: 5px;
  ${TitleText} {
    color: #01A8CE;
  }
`;
